import React from "react";

const Tutorials = () => <div>Tutorials </div>;

export default Tutorials;
